// eslint-disable-next-line import/prefer-default-export
export enum Store {
  default = 'default',
  en = 'shopmarriott_en',
  de = 'shopmarriott_de',
  fr = 'shopmarriott_fr',
  es = 'shopmarriott_es',
}
